import { render, staticRenderFns } from "./PopupLauncher.vue?vue&type=template&id=dd106770&scoped=true&"
import script from "./PopupLauncher.vue?vue&type=script&lang=js&"
export * from "./PopupLauncher.vue?vue&type=script&lang=js&"
import style0 from "./PopupLauncher.vue?vue&type=style&index=0&id=dd106770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd106770",
  null
  
)

export default component.exports